"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = capitalize;
var _utils = require("../utils");
var _lib = require("../lib");
function capitalize(value) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  (0, _utils.assertString)(value);
  var message = options.message;
  var key = options.key || 'key';
  var validity = (0, _utils.createValidity)(key);
  if (value.length > 0 && !(value === value.toUpperCase())) {
    var label = options.label || 'Field';
    var defaultMsg = "".concat(label, " is required to use all caps");
    var messageOptions = {
      key: key,
      message: message,
      label: label
    };
    validity.isValid = false;
    validity.message = (0, _lib.getMessage)(messageOptions, defaultMsg);
  }
  return validity;
}


//////////////////
// WEBPACK FOOTER
// ./~/@mhub/web-validations/dist/validations/capitalize.js
// module id = 1868
// module chunks = 0